
import dayjs from '../plugins/dayjs'

function getYear() {
  return dayjs().format("YYYY");
}
function getToday() {
  return dayjs().format("DD.MM.YYYY");
}
function getNow() {
  return dayjs().format("HH:mm");
}

function getDate(date) {
  return dayjs(date).format("DD.MM.YYYY");
}

function getHour(date) {
  return dayjs(date).format("HH:mm");
}

function getDateWithHour(date) {
  return dayjs(date).format("DD.MM.YYYY HH:mm");
}

function openCustomerSummaryTab(customerId) {
  window.vm.$swal.close();
  return window.vm.$router.push(`/customer/${customerId}/details`);
}

export { getYear, getToday, getNow, getDate, getHour, getDateWithHour, openCustomerSummaryTab }
